module.exports = __webpack_public_path__ + "static/media/train-card18.bb396877.jpg";